import { Button, Stack } from "@mui/material";

import { scaleToFitTile, type ModelInfo } from "../../../model/modelInfo";
import type { ModelLook } from "../../../model/modelLook";
import { PanelSection } from "../PanelSection/PanelSection";
import { SliderField } from "../SliderField/SliderField";

interface TransformControlsProps {
  info: ModelInfo;
  look: ModelLook;
  onLookChange: (look: ModelLook) => void;
}

export function TransformControls({ info, look, onLookChange }: TransformControlsProps) {
  return (
    <PanelSection title="Transform">
      <SliderField
        label="Scale"
        value={look.scale}
        min={0.01}
        max={5}
        step={0.01}
        onChange={(scale) => onLookChange({ ...look, scale })}
      />
      <SliderField
        label="Rotation (degrees)"
        value={look.rotationYDegrees}
        min={-180}
        max={180}
        step={1}
        onChange={(rotationYDegrees) => onLookChange({ ...look, rotationYDegrees })}
      />
      <Stack direction="row" spacing={1}>
        <Button
          variant="outlined"
          onClick={() => onLookChange({ ...look, scale: scaleToFitTile(info) })}
          data-testid="viewer-fit"
        >
          Fit to tile
        </Button>
        <Button onClick={() => onLookChange({ ...look, scale: 1, rotationYDegrees: 0 })}>Reset</Button>
      </Stack>
    </PanelSection>
  );
}
